export const SET_USER_CONFIG = "SET_USER_CONFIG";
export const ACTION_CREATE_USER = "ACTION_CREATE_USER";
export const ACTION_CHANGE_PASSWORD = "ACTION_CHANGE_PASSWORD";
export const ACTION_IS_LOGGED_IN = "ACTION_IS_LOGGED_IN";
export const IS_LOGGED_IN = "IS_LOGGED_IN";
export const ACTION_LOGOUT = "ACTION_LOGOUT";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const ACTION_LOGIN = "ACTION_LOGIN";

